export async function modifySubscription(email, action){  
  const url = `/api/eloqua/modifySubscriptionForm/${encodeURIComponent(email)}/${encodeURIComponent(action)}`;
  console.log(url);
  const response = await fetch(url);
  const  data = await response.json();
  return data.code == 200;
}